import { makeStyles, Tooltip as TooltipUI } from "@material-ui/core";
import React from "react";

const useStyle = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    lineHeight: "normal",
  },
  value: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "initial",
  },
  bold: {
    fontWeight: 600,
  },
});

export const Tooltip = ({
  value,
  children,
  bold,
}: {
  value: any;
  bold?: boolean;
  children?: React.ReactNode;
}) => {
  const classes = useStyle();
  return (
    <TooltipUI title={<p>{value}</p>}>
      <div className={classes.root}>
        {children ? (
          children
        ) : (
          <div className={classes.value + " " + (bold ? classes.bold : "")}>
            {value}
          </div>
        )}
      </div>
    </TooltipUI>
  );
};
